import { LanguageDetectorModule } from 'i18next';
import ClientCookies from 'universal-cookie';
import { Locale } from 'ggApp/types/common';

function getBrowserLocale(): string {
    return window?.navigator?.language?.split('-')?.[0] ?? '';
}

const i18nextLanguageDetector: LanguageDetectorModule = {
    type: 'languageDetector',
    init: () => {},
    detect: () => {
        const cookies = new ClientCookies();
        // TODO: probably will require different approach, e.g. fetching user preferred locale
        const currentLocale = cookies.get('locale') ?? getBrowserLocale();

        return Object.values<string>(Locale).includes(currentLocale) ? currentLocale : Locale.en;
    },
    cacheUserLanguage() {},
};

export default i18nextLanguageDetector;
